/* eslint-disable react/prop-types */
import classes from "./composed-view-five.module.scss";
import Label from "@/components-library/widgets/label";
import Flex from "@/components-library/layout/flex";
import Button from "@/components-library/widgets/button";
import classNames from "classnames";
function ComposedViewFive({ title, content, button, onClick, className }) {
  return (
    <Flex
      align="center"
      direction="column"
      justify="space-between"
      className={classNames(classes.container, className)}
    >
      <Flex
        align="center"
        direction="column"
        justify="center"
        className={classes.banner}
      >
        <Label tag="h5" weight="bold" className={classes.title}>
          {title}
        </Label>
        {content && (
          <Label tag="p" size="md" className={classes.content}>
            {content}
          </Label>
        )}
        {button && (
          <Button
            onClick={onClick}
            size="sm"
            color="secondary"
            className={classes.button}
          >
            {button.title}
          </Button>
        )}
      </Flex>
    </Flex>
  );
}

export default ComposedViewFive;
